
import Italic from "../../../assets/duotone/Italic.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ItalicIcon({ className, dataTestid = "ItalicIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Italic data-testid={dataTestid} className={classes} {...rest} />
  );
}
